import { RenderAST } from 'mk2/components/RenderAST';
import { isASTEmpty, ShowPhotosAndVideos } from 'mk2/helpers/article_ast/filters';
import { ContentItemEntity } from 'mk2/schemas';
import React from 'react';
import styles from './FacetHelp.mscss';

interface OwnProps {
    help: ContentItemEntity;
}

type Props = OwnProps;

export const FacetHelp: React.FunctionComponent<Props> = ({
    help,
}) => {
    if (isASTEmpty(help.contentAST)) {
        return null;
    }

    return (
        <div className={styles.FacetHelp}>
            <RenderAST
                contentAST={help.contentAST}
                linkedObjects={help.contentASTAdditionalData.linkedObjects}
                showPhotosAndVideos={ShowPhotosAndVideos.ALL}
                renderSpecialWikiLinks={false}
                customStyles={{
                    paragraph: styles.FacetHelp__paragraph,
                    youtube: styles.FacetHelp__youtube,
                }}
            />
        </div>
    );
};

FacetHelp.displayName = 'FacetHelp';
